import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle } from '../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../theme';
import { minorResultSharedStyles } from './Results.styles';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useMinorTestResultStyles = makeStyles(() => ({
  page: {
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      paddingLeft: 80,
      paddingRight: 80,
    },
  },
  contentContainer: {
    width: '100%',
    maxWidth: 1081,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
  },
  headerSection: {
    position: 'relative',
    width: '100%',
    minHeight: 40,
  },
  backButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    margin: 0,
    padding: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.text,
    lineHeight: 'normal',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  historyAnchor: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 2,
  },
  mainGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    width: '100%',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      display: 'grid',
      gridTemplateColumns: '459px minmax(0, 562px)',
      gridTemplateRows: 'auto auto',
      columnGap: 60,
      rowGap: 10,
      alignItems: 'start',
      justifyContent: 'space-between',
    },
  },
  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
    width: '100%',
    marginBottom: spacing.lg,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      width: 459,
      maxWidth: 459,
      flexShrink: 0,
      marginBottom: 0,
      gridColumn: 1,
      gridRow: 2,
    },
  },
  titleGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  rightColumn: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: 40,
    minWidth: 0,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      maxWidth: 562,
      gridColumn: 2,
      gridRow: 2,
    },
  },
  resultEyebrow: {
    margin: 0,
    marginBottom: 10,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.intro,
    color: colors.primaryDark,
    lineHeight: '28px',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      marginBottom: 0,
      gridColumn: 1,
      gridRow: 1,
    },
  },
  resultTitle: {
    margin: 0,
    padding: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.xxl,
    color: colors.primary,
    lineHeight: 1.15,
    '& p, & h1, & h2, & h3, & h4, & h5, & h6, & div': {
      margin: '0 !important',
      padding: 0,
      lineHeight: 'inherit',
      fontSize: 'inherit',
      fontFamily: 'inherit',
      color: 'inherit',
    },
    '& > *:first-child': {
      marginTop: '0 !important',
      paddingTop: 0,
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.xl,
    },
  },
  mediaStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    width: '100%',
  },
  resultImage: {
    width: '100%',
    height: 459,
    objectFit: 'cover',
    display: 'block',
    backgroundColor: colors.progressTrackMuted,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      height: 'auto',
      aspectRatio: '1 / 1',
    },
  },
  videoWrap: {
    width: '100%',
    borderRadius: radius.sm,
    overflow: 'hidden',
    backgroundColor: colors.progressTrackMuted,
  },
  retakeButton: {
    ...primaryButtonStyle,
    width: '100%',
  },
  retakeIcon: {
    ...minorResultSharedStyles.icon16,
  },
  aiSection: {
    width: '100%',
    marginTop: spacing.lg,
  },
  invalidState: {
    minHeight: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.lg,
    textAlign: 'center',
  },
  invalidTitle: {
    margin: '0 0 20px',
    fontFamily: fonts.gothicBold,
    fontSize: fontSize.xxl,
    color: colors.overlay,
    lineHeight: 1.5,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.xl,
    },
  },
  invalidDescription: {
    margin: '0 0 24px',
    fontFamily: fonts.opensans,
    fontSize: fontSize.lg,
    color: colors.overlay,
    lineHeight: 1.2,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.md,
    },
  },
  hiddenDiagram: {
    display: 'none',
  },
}));

// Above sticky AppHeader (1302) so toasts are not covered on mobile
const SNACKBAR_Z_INDEX = 1400;
const MOBILE_SNACKBAR_TOP = 'calc(80px + env(safe-area-inset-top, 0px))';

export const useMinorTestResultSnackbarStyles = makeStyles({
  '@global': {
    '.Snackbar_snackbar-wrapper__ocbPJ': {
      zIndex: `${SNACKBAR_Z_INDEX} !important`,
    },
    '.Snackbar_snackbar-wrapper-top-center__1Gbfi': {
      top: `${MOBILE_SNACKBAR_TOP} !important`,
    },
  },
});

export { MOBILE_SNACKBAR_TOP };
